import { css } from 'emotion'
// import { LINK_COLOR, LINK_COLOR_DARK  } from 'constants/styleConstants'

export const NotFoundMainStyles = css`
  padding: 16px;
`
